import React,{useRef,useEffect,useState,useLayoutEffect} from "react";
import Video from "app/(home)/Accueil.mp4";
import PagePermis from "app/apropos/Permis/PagePermis";
import PageFondateur from "app/apropos/Fondateur/PageFondateur";
import PageArchiveVideo from "app/(archives)/videos/page";
import PagePhotos from "app/photos/PagePhotos";
import PageServices from "app/services/page";
import PagePrix from "app/prix/page";
import PageContact from "app/(others)/contact/page";
import ImageMapper from 'react-img-mapper';
import "../../styles/styles.css";
import PageArticles from "app/articles/PageArticles";
import PageEvenements from "app/evenements/PageEvenements";
const URL = "images/transparentBg.png";


const PageHome = (myRef:any) => {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const elementRef = useRef(myRef);
 
  const MAP = {
    name: "my-map",
    areas: [
      { name: "1", shape: "poly", coords: [0,0,width/3,0,width/3,(height+75)/3,0,(height+75)/3], fillColor: "white",href:"video/eQ2-NE7-EV0"  },
      { name: "2", shape: "poly", coords: [width/3,0,2*width/3,0,2*width/3,(height+75)/3,width/3,(height+75)/3], fillColor: "white",href:"video/eQ2-NE7-EV0"  },
      { name: "3", shape: "poly", coords: [2*width/3,0,width,0,width,(height+75)/3,2*width/3,(height+75)/3],fillColor: "white",href:"/video/jlzeghVXeTk" },
      { name: "4", shape: "poly", coords: [0,(height+75)/3,width/3,(height+75)/3,width/3,2*(height+75)/3,0,2*(height+75)/3], fillColor: "white",href:"video/Zi5C8BVuL9U" },
      { name: "5", shape: "poly", coords: [width/3,(height+75)/3,2*width/3,(height+75)/3,2*width/3,2*(height+75)/3,width/3,2*(height+75)/3], fillColor: "white",href:"/video/bObhZz0aySo" },
      { name: "6", shape: "poly", coords: [2*width/3,(height+75)/3,width,(height+75)/3,width,2*(height+75)/3,2*width/3,2*(height+75)/3],fillColor: "white",href:"video/2GSjgjpXy7E"  },
      { name: "7", shape: "poly", coords: [0,2*(height+75)/3,width/3,2*(height+75)/3,width/3,height+75,0,height+75], fillColor: "white",href:"video/uNzAOBvrv68" },
      { name: "8", shape: "poly", coords: [width/3,2*(height+75)/3,2*width/3,2*(height+75)/3,2*width/3,height+75,width/3,height+75], fillColor: "white",href:"/video/-8CWMbCadRs" },
      { name: "9", shape: "poly", coords: [2*width/3,2*(height+75)/3,width,2*(height+75)/3,width,height+75,2*width/3,height+75], fillColor: "white",href:"/video/DCO32QcJplk" },
   
    ]
  }
  let resizeWindow = () => {
    setWidth(elementRef.current.getBoundingClientRect().width);
    setHeight(elementRef.current.getBoundingClientRect().height);
  };

  useLayoutEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []); //empty dependency array so it only runs once at render


  return (
      <>
        <div className="fullScreen">
          <div className="parent"> 
            <div style={{maxHeight:height}} className="overlay"> 
              <ImageMapper  src={URL} map={MAP} width={width} height={height} />
            </div>
            <video ref={elementRef} autoPlay loop muted className="center bg-vid"> 
              <source src={Video} type="video/mp4" /> 
            </video>
          </div> 
        </div>   
        <PageEvenements/>
        <PageArticles />
        <PagePhotos />
        <PageArchiveVideo />
        <PageContact />
      </>
  );
};

export default PageHome;
